export default __webpack_public_path__ + "static/Distribution-8d4390f7a198aa98fe5d4107668d7e4a.jpg";